import { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Row } from "react-bootstrap";
import { AddModal, EditModal } from "./Modals";
import { addPhotos, deleteAnImage, deletePhotos, editPhotos, fetchPhotos } from "../contexts/fetchGalleryData";

const dataStructure = [
    {
        title: "Add Images",
        type: "files",
        field: "imgs",
        init: [],
    },
    {
        title: "Title",
        type: "text",
        field: "title",
        init: "",
    },
    {
        title: "Description",
        type: "text",
        field: "des",
        init: "",
    },
    {
        title: "Hidden?",
        type: "switch",
        field: "hidden",
        init: false,
    },
    {
        title: "Date",
        type: "date",
        field: "date",
        init: "",
    },
]

const ColImageList = (props) => {
    const { imgs } = props;

    const handleDelete = async (path) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (!confirmDelete) return;

        try {
            await deleteAnImage(path);
            alert("Image deleted successfully.");
        } catch (error) {
            alert("Failed to delete image.");
            console.error(error);
        }
    };

    return (
        <Col xs="4">
            {Array.isArray(imgs) && imgs.length > 0 ? (
                imgs.map(({url, path}, i) => (
                    <div key={i} className="mb-3">
                        <img
                            src={url}
                            alt={`img-${i}`}
                            style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                borderRadius: "6px",
                                marginBottom: "0.5rem"
                            }}
                        />
                        <Button variant="danger" size="sm" onClick={() => handleDelete(path)}> Delete </Button>
                    </div>
                ))
            ) : (
                <div className="text-muted">No image available</div>
            )}
        </Col>
    );
};



const DBGallery = () => {

    const [isShowA, setShowA] = useState(false);
    const [isShowE, setShowE] = useState(false);
    const [data, setData] = useState([]);
    const [eData, setEData] = useState({});
    //const [imgs, setImgs] = useState({});

    useEffect(() => {
        fetchPhotos(setData);
        return () => {
            setShowA(false);
            setShowE(false);
            setData([]);
            setEData({});
        };
    }, []);

    const handleAddSubmit = async (e, data) => {
        e.preventDefault();
        try {

            if (!data.imgs || data.imgs.length === 0) {
                alert("Please select at least one image.");
                return;
            }

            if (data.imgs.length > 9) {
                alert("Maximum only 9 images");
                return;
            }

            for (const img of data.imgs) {
                if (!img) continue;
                if (img.size > 2 * 1024 * 1024) {
                    alert(`File "${img.name}" exceeds 2MB.`);
                    return;
                }
            }
            await addPhotos({ ...data });
            alert("Upload successful!");
            await fetchPhotos(setData);
            setShowA(false);
        } catch (error) {
            alert("Error uploading photo. Please try again.");
        }
    };

    const handleEditSubmit = async (e, data) => {
        e.preventDefault();
        try {
            for (const img of data.imgs) {
                if (!img) continue;
                if (img.size > 2 * 1024 * 1024) {
                    alert(`File "${img.name}" exceeds 2MB.`);
                    return;
                }
            }

            await editPhotos(data);
            alert("Upload successful!");
            await fetchPhotos(setData);
            setShowE(false);
        }
        catch (error) {
            alert("Error uploading photo. Please try again.");
        }
    }

    const deletePost = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this post?");
        if (!confirmDelete) return;

        try {
            await deletePhotos(id);
            alert("This post deleted successfully.");
            await fetchPhotos(setData);
        } catch (error) {
            alert("Failed to delete image.");
            console.error(error);
        }
    }

    return (
        <div>
            <div className="text-end">
                <Button variant="primary" onClick={() => setShowA(true)}>Add</Button>
            </div>
                
            {data.map((d) => (
                <Row key={d.id} className="align-items-center mb-4">
                    <ColImageList imgs={d.urls} />
                    <Col>
                        <h5>{d.title}</h5>
                        <p>{d.des}</p>
                        <p className="text-muted mb-2">Hidden: {d.hidden ? "Yes" : "No"}</p>
                        <ButtonGroup>
                            <Button variant="warning" onClick={() => {setEData(d); setShowE(true);}}>Edit</Button>
                            <Button variant="danger" onClick={() => deletePost(d.id)}>Delete</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            ))}
            <AddModal  isShowM={isShowA} setShowM={setShowA} structure={dataStructure} onSubmit={handleAddSubmit} />
            <EditModal isShowM={isShowE} setShowM={setShowE} structure={dataStructure} onSubmit={handleEditSubmit} existingData={eData}/>
            
        </div>
    )
}

export default DBGallery;